// extracted by mini-css-extract-plugin
module.exports = {"souvenir_manager":"souvenir_souvenir_manager__vaKnw","card":"souvenir_card__1Fp46"};